var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_79)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_79",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 0.5H0.5V30.5H38.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8333 4.49999C37.8333 2.48333 36.1833 0.833328 34.1666 0.833328H4.83329C2.81663 0.833328 1.16663 2.48333 1.16663 4.49999V26.5C1.16663 28.5167 2.81663 30.1667 4.83329 30.1667H34.1666C36.1833 30.1667 37.8333 28.5167 37.8333 26.5V4.49999ZM34.1666 4.49999L19.5 13.6667L4.83329 4.49999H34.1666ZM34.1666 26.5H4.83329V8.16666L19.5 17.3333L34.1666 8.16666V26.5Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e0d689cc1a28697ba6d2d9c2a76d87b8.svg";
export { ForwardRef as ReactComponent };